const SvgIcon = ({ Icon, className, title, onClick }) => {

    return (
        <Icon className={className}
            title={title}
            fill="currentColor" // Forzamos el uso de `currentColor`
            stroke="currentColor" // También para líneas o trazos
            onClick={onClick}
        />
    )
}

export default SvgIcon;